<div class="container p-5 mt-5">
  <div class="d-grid justify-content-center my-5">
    <img src="https://familyhappybenefit.com/wp-content/uploads/2025/06/Group-1609-2.svg" alt="">
  </div>
  <h2 class="text-center">{{title}}</h2>
  <ng-content></ng-content>
</div>
